// helpers/render-action-shop-button.helper.tsx

import dayjs from "dayjs";
import { ReactNode } from "react";
import { TFunction } from "i18next";
import { ShopGoodAccessStatus } from "../../constants";

type RenderActionShopButtonParams = {
	accessState: {
		status: ShopGoodAccessStatus;
		activeUntil: any;
	};
	isFree: boolean;
	t: TFunction;
	onBuy: () => void;
	ButtonBuyComponent: (props: any) => JSX.Element;
	PurchasedPlanBadgeComponent: (props: { children: ReactNode }) => JSX.Element;
	PurchasedPlanDateComponent: (props: { children: ReactNode }) => JSX.Element;
};

const formatAccessDate = (date: any) => {
	if (!date) {
		return "";
	}

	return dayjs(date).format("DD.MM.YYYY");
};

export const renderActionShopButton = ({
	accessState,
	isFree,
	t,
	onBuy,
	ButtonBuyComponent,
	PurchasedPlanBadgeComponent,
	PurchasedPlanDateComponent,
}: RenderActionShopButtonParams) => {
	if (isFree) {
		return null;
	}

	if (accessState.status === ShopGoodAccessStatus.UpgradeToAnnual) {
		return <ButtonBuyComponent onClick={onBuy}>{t("buttons.subscriptions.upgrade_to_annual")}</ButtonBuyComponent>;
	}

	if (accessState.status === ShopGoodAccessStatus.Active) {
		return (
			<PurchasedPlanBadgeComponent>
				<PurchasedPlanDateComponent>
					{t("buttons.subscriptions.active_until", {
						date: formatAccessDate(accessState.activeUntil),
					})}
				</PurchasedPlanDateComponent>
			</PurchasedPlanBadgeComponent>
		);
	}

	if (accessState.status === ShopGoodAccessStatus.CoveredByAnnual) {
		return (
			<PurchasedPlanBadgeComponent>
				<PurchasedPlanDateComponent>
					{t("buttons.subscriptions.included_until", {
						date: formatAccessDate(accessState.activeUntil),
					})}
				</PurchasedPlanDateComponent>
			</PurchasedPlanBadgeComponent>
		);
	}

	return <ButtonBuyComponent onClick={onBuy}>{t("buttons.buy_now")}</ButtonBuyComponent>;
};
